var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emoji-container"},_vm._l((_vm.configs),function(config){return _c('button',{key:config.type,staticClass:"emoji-button",on:{"click":() => _vm.onLike(config.type)}},[_vm._v(" "+_vm._s(config.icon)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }